export default class ValidateInputs{
	constructor(view, steps){
		console.log('ValidateInputs :: init',view);

		this.view = view;
		this.steps = steps;

	}

	validateStep(step){
		let valid = true;
		
		if(step == 0 || step == 1 || step == 2){
			valid = this.steps[step].querySelectorAll("input:checked").length == 0 ? false : true;

			//if still valid from last step, do this
			if(valid) if(step == 1) valid = Number(this.steps[step].querySelector('.fakeSelect .right .number').innerHTML) == 0 ? false : true;
		}

		return valid;
	}
}